import { useEffect, useState } from "react";
import { api, asArray } from "@/lib/api";
import { FileText } from "lucide-react";

export default function Docs() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/docs").then(r => setItems(asArray(r.data))); }, []);
  return (
    <div className="space-y-4">
      <div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">Documentation Management</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Knowledge Repository ({items.length})</h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {items.map(d => (
          <div key={d.id} className="bg-zinc-950 border border-zinc-900 rounded-md p-4 hover:border-zinc-800" data-testid={`doc-card-${d.id}`}>
            <div className="flex items-center gap-2"><FileText size={14} className="text-blue-400"/><div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono">{d.doc_type} · v{d.version}</div></div>
            <h2 className="font-display text-base tracking-tight mt-1">{d.title}</h2>
            <div className="text-xs text-zinc-500 mt-2 line-clamp-2">{d.content}</div>
            <div className="flex gap-1 mt-3">
              {(d.tags || []).map(t => <span key={t} className="text-[10px] bg-zinc-900 border border-zinc-800 rounded px-2 py-0.5 font-mono text-zinc-400">{t}</span>)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
